// extracted by mini-css-extract-plugin
export default {"carets":"styles_carets__1Mkpk"};